import React from 'react';
import classnames from 'classnames';

import ArrowGoBackLineIcon from 'remixicon-react/ArrowGoBackLineIcon';
import Attachment2Icon from 'remixicon-react/Attachment2Icon';
import Battery2ChargeLineIcon from 'remixicon-react/Battery2ChargeLineIcon';
import BubbleChartFillIcon from 'remixicon-react/BubbleChartFillIcon';
import CheckboxCircleLineIcon from 'remixicon-react/CheckboxCircleLineIcon';
import CodeBoxLineIcon from 'remixicon-react/CodeBoxLineIcon';
import CodeLineIcon from 'remixicon-react/CodeLineIcon';
import CheckboxFill from '../svg/icons/remix-checkbox-fill.svg';
import DashboardFill from '../svg/icons/remix-dashboard-fill.svg';
import DatabaseLineIcon from 'remixicon-react/DatabaseLineIcon';
import DeviceLineIcon from 'remixicon-react/DeviceLineIcon';
import EyeLineIcon from 'remixicon-react/EyeLineIcon';
import FlashlightLineIcon from 'remixicon-react/FlashlightLineIcon';
import GitBranchLineIcon from 'remixicon-react/GitBranchLineIcon';
import GraphQL from '../svg/icons/graphql.svg';
import GroupLine from '../svg/icons/remix-group-line.svg';
import Layout3LineIcon from 'remixicon-react/Layout3LineIcon';
import LayoutMasonryFill from '../svg/icons/remix-layout-masonry-fill.svg';
import LightbulbFlashLineIcon from 'remixicon-react/LightbulbFlashLineIcon';
import LineChartLineIcon from 'remixicon-react/LineChartLineIcon';
import ListCheck2Icon from 'remixicon-react/ListCheck2Icon';
import Medal2FillIcon from 'remixicon-react/Medal2FillIcon';
import RefreshLineIcon from 'remixicon-react/RefreshLineIcon';
import ShieldCheckLineIcon from 'remixicon-react/ShieldCheckLineIcon';
import ShieldFlashLine from '../svg/icons/remix-shield-flash-line.svg';
import ShieldUserLineIcon from 'remixicon-react/ShieldUserLineIcon';
import ServerLineIcon from 'remixicon-react/ServerLineIcon';
import SpeedFill from '../svg/icons/remix-speed-fill.svg';
import StackLineIcon from 'remixicon-react/StackLineIcon';
import TerminalLineIcon from 'remixicon-react/TerminalLineIcon';
import TimeLineIcon from 'remixicon-react/TimeLineIcon';
import TimerFlashLineIcon from 'remixicon-react/TimerFlashLineIcon';
import Translate2Icon from 'remixicon-react/Translate2Icon';
import TreasureMapLineIcon from 'remixicon-react/TreasureMapLineIcon';
import TrophyLineIcon from 'remixicon-react/TrophyLineIcon';
import UserAddLineIcon from 'remixicon-react/UserAddLineIcon';
import UserStarFill from '../svg/icons/remix-user-star-fill.svg';
import UserLineIcon from 'remixicon-react/UserLineIcon';

const RemixIcon = ({ className, icon, size = 'regular' }) => {
  const sizeClass = (size) => {
    switch (size) {
      case 'regular':
      default:
        return 'h-5 w-5';
    }
  };

  switch (icon) {
    case 'ArrowGoBackLineIcon':
      return (
        <ArrowGoBackLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'Attachment2Icon':
      return (
        <Attachment2Icon className={classnames(sizeClass(size), className)} />
      );
    case 'Battery2ChargeLineIcon':
      return (
        <Battery2ChargeLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'BubbleChartFillIcon':
      return (
        <BubbleChartFillIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'CheckboxCircleLineIcon':
      return (
        <CheckboxCircleLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'CodeBoxLineIcon':
      return (
        <CodeBoxLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'CODE_FILL':
    case 'CodeLineIcon':
      return (
        <CodeLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'CHECKBOX_FILL':
      return (
        <CheckboxFill className={classnames(sizeClass(size), className)} />
      );
    case 'DASHBOARD_FILL':
      return (
        <DashboardFill className={classnames(sizeClass(size), className)} />
      );
    case 'DatabaseLineIcon':
      return (
        <DatabaseLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'DeviceLineIcon':
      return (
        <DeviceLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'EyeLineIcon':
      return <EyeLineIcon className={classnames(sizeClass(size), className)} />;
    case 'FlashlightLineIcon':
      return (
        <FlashlightLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'GitBranchLineIcon':
      return (
        <GitBranchLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'GRAPHQL':
      return <GraphQL className={classnames(sizeClass(size), className)} />;
    case 'GROUP_LINE':
      return <GroupLine className={classnames(sizeClass(size), className)} />;
    case 'Layout3LineIcon':
      return (
        <Layout3LineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'LAYOUT_MASONRY_FILL':
      return (
        <LayoutMasonryFill className={classnames(sizeClass(size), className)} />
      );
    case 'LightbulbFlashLineIcon':
      return (
        <LightbulbFlashLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'LineChartLineIcon':
      return (
        <LineChartLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'LIST_CHECK_2':
    case 'ListCheck2Icon':
      return (
        <ListCheck2Icon className={classnames(sizeClass(size), className)} />
      );
    case 'Medal2FillIcon':
      return (
        <Medal2FillIcon className={classnames(sizeClass(size), className)} />
      );
    case 'RefreshLineIcon':
      return (
        <RefreshLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'ShieldCheckLineIcon':
      return (
        <ShieldCheckLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'SHIELD_FLASH_LINE':
      return (
        <ShieldFlashLine className={classnames(sizeClass(size), className)} />
      );
    case 'ShieldUserLineIcon':
      return (
        <ShieldUserLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'ServerLineIcon':
      return (
        <ServerLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'SPEED_FILL':
      return <SpeedFill className={classnames(sizeClass(size), className)} />;
    case 'StackLineIcon':
      return (
        <StackLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'TerminalLineIcon':
      return (
        <TerminalLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'TimeLineIcon':
      return (
        <TimeLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'TimerFlashLineIcon':
      return (
        <TimerFlashLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'TRANSLATE_2':
    case 'Translate2Icon':
      return (
        <Translate2Icon className={classnames(sizeClass(size), className)} />
      );
    case 'TreasureMapLineIcon':
      return (
        <TreasureMapLineIcon
          className={classnames(sizeClass(size), className)}
        />
      );
    case 'TrophyLineIcon':
      return (
        <TrophyLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'UserAddLineIcon':
      return (
        <UserAddLineIcon className={classnames(sizeClass(size), className)} />
      );
    case 'USER_STAR_FILL':
      return (
        <UserStarFill className={classnames(sizeClass(size), className)} />
      );
    case 'UserLineIcon':
      return (
        <UserLineIcon className={classnames(sizeClass(size), className)} />
      );
    default:
      return null;
  }
};

export default RemixIcon;
